type Props = {
  children: any
}

function Fade(props: Props) {
  return (
    <div className="animate__animated animate__fadeIn animate__faster">
      {props.children}
    </div>
  )
}

export default Fade
